import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field']

  clean() {
    const value = this.fieldTarget.value
      .trim()
      .replace(/^https?:\/\//i, '')
      .replace(/\/+$/, '')

    this.fieldTarget.value = value
  }
}
